import { faStopwatch } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardContent } from '@repo/videa-components/src/index';
import { useAtom, useAtomValue } from 'jotai';

import {
  recorderStatusAtom,
  recordingDurationAtom,
  stoppedRecordingDurationAtom,
} from '../atoms';
import { useRecordingTimer } from '../hooks/useRecordingTimer';

// format time in HH:MM:SS
export const formatTime = (secondsInput: number): string => {
  const totalSeconds = Math.round(secondsInput); // round to nearest second

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

// Could potentially use format from date-fns for this calculation.
// Something like: format(new Date(seconds * 1000), 'mm:ss').

const TimerDisplay = () => {
  const duration = useAtomValue(recordingDurationAtom);
  const durationOfPreviousRecording = useAtomValue(
    stoppedRecordingDurationAtom,
  );
  const [status] = useAtom(recorderStatusAtom);

  useRecordingTimer(); // hook for the recording duration timer

  const isRecordingPaused = () => status === 'paused';
  const isRecordingActive = () => status === 'recording';
  const isRecordingStopped = () => ['idle', 'stopped'].includes(status);

  return (
    <Card className="vai-w-fit vai-px-3 vai-py-2">
      <CardContent className="vai-flex vai-items-center vai-gap-3 !vai-p-0">
        <span className="vai-relative vai-h-4 vai-w-4">
          {/* show a red "stop" square */}
          {isRecordingPaused() && (
            <>
              <span className="vai-absolute vai-inline-flex vai-h-full vai-w-full vai-bg-red-500 vai-opacity-75" />
              <span className="vai-absolute vai-inline-flex vai-h-4 vai-w-4 vai-bg-red-600" />
            </>
          )}
          {/* show a blinking red "recording" circle */}
          {isRecordingActive() && (
            <>
              <span className="vai-absolute vai-inline-flex vai-h-full vai-w-full vai-rounded-full vai-bg-red-500 vai-opacity-75 vai-animate-ping" />
              <span className="vai-absolute vai-inline-flex vai-h-4 vai-w-4 vai-rounded-full vai-bg-red-600" />
            </>
          )}
          {/* default: show a stopwatch icon */}
          {isRecordingStopped() && (
            <FontAwesomeIcon
              className="vai-text-[#4A4F55] vai-absolute vai-inline-flex vai-h-full vai-w-full"
              icon={faStopwatch}
              size="3x"
            />
          )}
        </span>
        <span
          className={`vai-font-mono vai-text-sm ${isRecordingActive() ? 'vai-text-red-700' : 'vai-text-black-900'}`}
        >
          {formatTime(
            durationOfPreviousRecording
              ? durationOfPreviousRecording
              : duration,
          )}
        </span>
      </CardContent>
    </Card>
  );
};

export default TimerDisplay;
